import ExternalLink from "@/components/ui/ExternalLink";
import { OFFICIAL_LINE } from "@/constants/common";

interface OfficialLINEProps {
  classes?: string;
}

const OfficialLINE = ({ classes = "" }: OfficialLINEProps) => {
  return (
    <ExternalLink href={OFFICIAL_LINE.LINK} classes={classes}>
      小院店家 LINE
    </ExternalLink>
  );
};

export default OfficialLINE;
